module.exports = __webpack_public_path__ + "static/media/corporate-services-img21.ebb10fd9.jpg";